module.exports = __webpack_public_path__ + "img/beginningletter.70c0b7f7.png";